import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { IconButton } from '@lifeomic/chroma-react/components/IconButton';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { Copy } from '@lifeomic/chromicons';
import React, { useCallback } from 'react';

const useStyles = makeStyles(theme => ({
  capitalize: {
    textTransform: 'capitalize',
  },
  copyButton: {
    marginLeft: theme.spacing(0.5),
  },
}));

interface SequenceDetailsValueProps {
  value?: string;
  preserveCase?: boolean;
}

export const SequenceDetailsValue: React.FC<SequenceDetailsValueProps> = ({
  value,
  preserveCase,
  ...rootProps
}) => {
  const classes = useStyles({});

  const handleCopy = useCallback(() => {
    if (value != null && navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value);
    }
  }, [value]);

  return (
    <Box align="center" gap={0.5} {...rootProps}>
      <Text
        className={!preserveCase ? classes.capitalize : undefined}
        size="subbody"
      >
        {value}
      </Text>
      {value != null && value !== '' && (
        <Tooltip title="Copy">
          <span className={classes.copyButton}>
            <IconButton
              aria-label="Copy to clipboard"
              icon={Copy}
              onClick={handleCopy}
              size={0}
              paddingTop={0}
              paddingBottom={0}
            />
          </span>
        </Tooltip>
      )}
    </Box>
  );
};
